<template>
    <div>
        <div class="wrapper-search">
            <div class="wrapper-search-line" v-if="!isSearch">
                <div class="title" :class="{'font-bold-en' : localeCode == 1033}">{{lbl.home.your_privileges}}</div>
                <div class="wrapper-icon-search" @click="clickSearch()">
                    <img
                        class="icon-search"
                        src="../assets/home/search@2x.png"
                    />
                </div>
            </div>
            <div class="wrapper-search-line" v-if="isSearch">
                <div class="wrapper-input-search" >
                    <input type="text" class="input-search" v-model="strSearch" v-on:keyup.enter="checkEnter" />
                    <span class="search-placeholder" v-show="!strSearch">{{lbl.home.search}}</span>
                    <img
                        class="icon-clear"
                        src="../assets/home/icon-search-close@2x.png"
                        v-if="strSearch"
                        @click="clickClearSearch()"
                    />
                </div>

                <div  class="wrapper-cancel" >

                    <div @click="clickCancel()" class="btn-cancel">{{lbl.home.cancel}}</div>
                    <div class="wrapper-icon-btn-search" @click="checkEnter()">
                        <img
                            class="icon-btn-search"
                            src="../assets/home/icon_search_white.png"
                        />
                    </div>
                </div>

            </div>
        </div>
        <category-menu
            :locale="localeCode"
            :strConfig="menuConfig"
            :selectCateId="selectCateId"
            :busEven="busCateMenu"
            v-if="isLoaded"
        ></category-menu>
        <div class="container wrapper-campaign-list">
            <div>
                <campaign-list
                    :lbl="lbl"
                    :objListConfig="listConfig"
                    :objFilterConfig="filterConfig"
                    :busEvent="busCampaign"
                    v-if="isLoaded"
                ></campaign-list>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Locale from "@/helper/locale/locale.js";
import Account from "@/helper/AccountHelper.js";
import DateTime from "@/helper/DatetimeHelper.js";

import CategoryMenu from "@/components/campaign/filter/CategoryMenu.vue";
import CampaignList from "@/components/campaign/list/CampaignList.vue";
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/service/config/CampaignConfigModel.js";
export default {
    name: "CampaignWithFilter",
    components: {
        CategoryMenu,
        CampaignList
    },
    data: function() {
        return {
            isLoaded: false,
            isSearch: false,
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocale().code,
            strSearch: "",
            listConfig: {},
            filterConfig: {},
            catId: "",
            selectCateId: undefined,
            menuConfig: Vue.bzbsConfig.mainConfig.MenuConfig,
            campaignListConfig: Vue.bzbsConfig.mainConfig.CampaignListConfig,
            busCateMenu: new Vue(),
            busCampaign: new Vue(),
            busModal: new Vue()
        };
    },
    created: function() {
        this.initialConfig();
    },
    mounted: function() {
        this.busCateMenu.$on("clickcategory", config => {
            this.reinitialConfig(config);
        });
    },
    methods: {
        reinitialConfig: function(config) {
            // Account.setCacheCustom('categoryId',config.id);
            this.strSearch = "";
            this.catId = config.id;
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(config.list_config)
                .setCatId(config.id)
                .create();
            var filterConfig = new CampaignListFilterConfigBuilder().create();
            var objConfig = {
                listConfig: listConfig,
                filterConfig: filterConfig
            };
            this.busCampaign.$emit("reinitList", objConfig);
            this.isLoaded = true;
        },
        initialConfig: function() {
            this.selectCateId = Account.getCacheCustom('categoryId');
            // Account.removeCacheCustom('categoryId');
            if(!this.selectCateId || this.selectCateId == "undefined") {
                this.selectCateId = undefined;
            }

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.campaignListConfig)
                .setCatId(this.selectCateId)
                .create();
            this.listConfig = listConfig;

            var filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
            this.isLoaded = true;
        },
        clickSearch: function() {
            this.isSearch = true;
            this.selectCateId = undefined;
            this.catId = undefined;


            var gtm = {
                 "event_label": "search",
                 "timestamp": DateTime.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege", "click_buttons", gtm.event_label, null, gtm);

            this.checkEnter();

        },
        clickClearSearch: function() {
            this.strSearch = "";
            this.checkEnter();
            //this.busCateMenu.$emit("reinitCategory", {});
        },
        clickCancel: function() {
            this.isSearch = false;
            this.strSearch = "";
            var gtm = {
                "event_label": "-",
                "timestamp": DateTime.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege", "cancel_search", gtm.event_label, null, gtm);
            this.checkEnter();
        },
        checkEnter: function() {
            this.selectCateId = undefined;
            this.catId = undefined;
            this.busCateMenu.$emit("reinitCategory", {});
            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(this.campaignListConfig)
                .setCatId(this.catId)
                .create();
            var filterConfig = new CampaignListFilterConfigBuilder()
                .setSearch(this.strSearch)
                .create();

            var objConfig = {
                listConfig: listConfig,
                filterConfig: filterConfig
            };

            if (this.strSearch != "") {
                var gtm = {
                    "event_label": this.strSearch,
                    "timestamp": DateTime.getDateTimeGTM()
                };

                Vue.ga.event(this, "privilege", "search", gtm.event_label, null, gtm);
            }


            this.busCampaign.$emit("reinitList", objConfig);
            this.isLoaded = true;
        }

    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
.wrapper-search {
    width: 100%;
    padding: 0 15px;
    .wrapper-search-line {
        width: 100%;
        display: inline-block;
        padding: 15px 0 0 0;

        .title {
            width: auto;
            // font-size: 1.5em;
            font-size: 26px;
            float: left;
            font-weight: bold;
        }

        .wrapper-icon-search {
            float: right;
            width: 27px;
            padding: 6px;
            border-radius: 50%;
            margin-top: 5px;
            background-color: $background-gray-color;
            cursor: pointer;

            .icon-search {
                float: right;
                width: 100%;
            }
        }

        .wrapper-input-search {
            width: 65%;
            float: left;
            background-color: $background-gray-color;
            height: 35px;
            border-radius: 30px;
            margin-top: 3px;
            position: relative;

            .input-search {
                border: none;
                background-color: transparent;
                padding: 0;
                font-size: 1em;
                width: 72%;
                line-height: 1.3em;
                margin-left: 15px;
                margin-top: 5px;
            }

            .input-search:focus {
                outline: none;
            }

            .icon-search {
                width: 15px;
                position: absolute;
                top: 10px;
                left: 10px;
            }

            .icon-clear {
                width: 15px;
                position: absolute;
                top: 11px;
                right: 8px;
            }

            .search-placeholder {
                position: absolute;
                color: $gray-color;
                left: 15px;
                top: 3px;
            }
        }

        .wrapper-cancel {
            width: 35%;
            float: right;
            text-align: center;
            margin-top: 5px;
            font-weight: bold;
            font-size: 1em;
            color: #b6b7b9;

            .btn-cancel {
                width: 50%;
                float:right;
            }

            .wrapper-icon-btn-search {
                float: left;
                width: 32px;
                padding: 10px;
                border-radius: 50%;
                margin-top: 0px;
                margin-left: 15px;
                background-color: #00a4e4;
                cursor: pointer;

                .icon-btn-search {
                    float: right;
                    width: 100%;
                }
            }
        }
    }
}

.wrapper-campaign-list {
    background-color: $background-gray-color;
    min-height: 100vh;
}
</style>
